import React, { useEffect, useRef, useState } from "react";
import "./GenericChatbotContainer.css";
import iq_api_v2 from "../../../../services/iqApiV2";
import { useParams } from "react-router-dom";
import { useUser } from "../../../../context/UserContext";
import { useDispatch, useSelector } from "react-redux";
import { fetchOpportunitiesRequest } from "../../../../store/features/actions/opportunities/opportunitesActions";
import { fetchWinOpportunitiesRequest } from "../../../../store/features/actions/opportunities/winOpportunitiesActions";
import SelectDropDownComp from "./selectDropDownComp";
import { FetchMeetingPrepsRequest } from "../../../../store/features/actions/meetingPrep/meetingPrepsActions";
import { useBanner } from "../../../../context/BannerContext";
import qs from 'qs'
import { PROJECT_DISPLAY_NAME } from "../../../../config/apiConfig";
import DatePicker from "react-datepicker";

const AddContactForm = ({ dropDownData, onApplyDropdown }) => {
  const [selectedOpportunities, setSelectedOpportunitites] = useState();
  
  return (
    <div className="chatbot-add-container">
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span className="chatbot-form-text-titl">Please choose opportunity</span>
        <span
          className="chatbot-form-text-titl clickable"
          onClick={() => setSelectedOpportunitites([])}
        >
          Clear
        </span>
      </div>
      <SelectDropDownComp
        allOptions={dropDownData}
        selectedValues={selectedOpportunities}
        setSelectedValues={setSelectedOpportunitites}
        onApply={onApplyDropdown}
        multiSelect={true}
        valueKey="_id"
        labelKey="opportunity_name"
        disableFooter={false}
      />
    </div>
  );
};


const SelectMeetingTimeForm = ({  handleUserInput }) => {
  const [meeting_start_date, setMeetingStartDate] = useState(null)
  const [meeting_end_date, setMeetingEndDate] = useState(null)
  const [disabledApply, setDisabledApply] = useState(false)

  const showBanner = useBanner()

  const setDateToNull = () => {
    setMeetingStartDate("");
    setMeetingEndDate("");
    setDisabledApply(false)
  }

  const handleOnApply = () => {
    
    //handleUserInput(meeting_start_date+":::"+meeting_end_date)

    const meeting_start_date_1 = new Date(meeting_start_date);
    const meeting_end_date_1 = new Date(meeting_end_date);
    const now = new Date();

    // Check if start date is in the future
    if (meeting_start_date_1 <= now) {
        console.log("Error: Meeting start date should be in the future.");
        showBanner({ message: 'Meeting start date should be in the future.',title:"Alert", type: 'error', duration: 10000 })

        return false;
    }else if (meeting_end_date_1 <= meeting_start_date_1) { // Check if end date is after start date
        console.log("Error: Meeting end date should be after the start date.");
        showBanner({ message: 'Meeting end date should be after the start date.',title:"Alert", type: 'error', duration: 10000 })
        return false;
    }

    setDisabledApply(true)

    handleUserInput({"meeting_date_time": {
      "meeting_start" : meeting_start_date,
      "meeting_end" : meeting_end_date,
    }})
    return 
  }

  const handleDateChange = (name, date, onApply) => {

    if(name === 'meeting_start_date'){
      setMeetingStartDate(date);
    }else{
      setMeetingEndDate(date);
    }

    // Clear date-related errors
    if (['subscriptionStartDate', 'subscriptionEndDate'].includes(name)) {
      // setErrors((prevErrors) => ({
      //   ...prevErrors
      //   subscriptionEndDate: '',
      // }));
    }

    // Clear API error
    // setApiError('');
  };
  
  return (
    <div className="chatbot-add-container">
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span className="chatbot-form-text-titl">Please select meeting date</span>
        <span
          className="chatbot-form-text-titl clickable"
          onClick={() => setDateToNull()}
        >
          Clear
        </span>
      </div>
      <div className="row mb-2">
        <div className="col-md-6">
          <label>Meeting Start Time:</label>
          <DatePicker
              disabled={disabledApply}
              selected={meeting_start_date}
              onChange={(date) => handleDateChange('meeting_start_date', date)}
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={15}
              dateFormat="MMMM d, yyyy h:mm aa"
              placeholderText="Select date and time"
          />
        </div>
      </div>

      <div className="row  mb-2">
        <div className="col-md-6">
          <label>Meeting End Time:</label>
          <DatePicker
              disabled={disabledApply}
              selected={meeting_end_date}
              onChange={(date) => handleDateChange('meeting_end_date', date)}
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={15}
              dateFormat="MMMM d, yyyy h:mm aa"
              placeholderText="Select date and time"
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <button
            disabled={disabledApply}
            className={`${disabledApply == true ? 'btn btn-primary' : 'apply-btn'}`}
            onClick={() =>{
              handleOnApply()}}
          >
            Apply
          </button>
        </div>
      </div>

    </div>
  );
};

const ChatContainerForMeetingPrep = ({ onBack, type }) => {
  const dispatch = useDispatch();
  const { clientName, accountName } = useParams();
  const { user } = useUser();
  const [meeting_start_date, setMeetingStartDate] = useState(null)
  const [meeting_end_date, setMeetingEndDate] = useState(null)
  

  const [chatMessages, setChatMessages] = useState([]);
  const [message, setMessage] = useState("");
  const [oppData, setOppData] = useState({ contact_name: "", objective: "", linkedin_url: "", client: "", account: "" });
  const [isMeetingFlowActive, setIsMeetingFlowActive] = useState(true);

  const textareaRef = useRef(null);
  const containerRef = useRef(null);

  const { opportunitesData, opportunitesLoading } = useSelector(
    (state) => state.opportunitiesReducer
  );
  const { winOpportunitesData, winOpportunitesLoading } = useSelector(
    (state) => state.winOpportunitiesReducer
  );
  const initializeChat = () => {
    setChatMessages([{
      sender: PROJECT_DISPLAY_NAME,
      message: `Hi ${user?.firstname}! 👋 Please enter the contact name.`,
      timestamp: getTime()
    }]);
  };
    const showBanner = useBanner()


  useEffect(() => {
    initializeChat();
  }, []);
  useEffect(() => {
    if (clientName && accountName && user?.id) {
      if (opportunitesData?.length === 0)
        dispatch(
          fetchWinOpportunitiesRequest({
            clientName,
            accountName,
            userId: user.id,
            type: "win",
          })
        );
      if (winOpportunitesData?.length === 0)
        dispatch(
          fetchOpportunitiesRequest({
            clientName,
            accountName,
            userId: user.id,
            type: "spot",
          })
        );
    }
  }, [clientName, accountName, user?.id]);

  const getTime = () =>
    new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

  const pushMessage = (sender, message, isLoading = false) => {
    setChatMessages((prev) => [
      ...prev,
      { sender, message, isLoading, timestamp: !isLoading ? getTime() : undefined },
    ]);
  };

  const updateLastMessage = (message) => {
    setChatMessages((prev) => {
      const updated = [...prev];
      updated[updated.length - 1] = {
        ...updated[updated.length - 1],
        message,
        isLoading: false,
        timestamp: getTime(),
      };
      return updated;
    });
  };

  // const handleDateChange = (name, date) => {

  //   if(name === 'meeting_start_date'){
  //     setMeetingStartDate(date);
  //   }else{
  //     setMeetingEndDate(date);
  //   }

    

  //   // Clear date-related errors
  //   if (['subscriptionStartDate', 'subscriptionEndDate'].includes(name)) {
  //     // setErrors((prevErrors) => ({
  //     //   ...prevErrors
  //     //   subscriptionEndDate: '',
  //     // }));
  //   }

  //   // Clear API error
  //   // setApiError('');
  // };

  const convertDateTimeToPassAPI = (inputDate) => {
    
    const pad = (n) => (n < 10 ? "0" + n : n);

    const day = pad(inputDate.getDate());
    const month = pad(inputDate.getMonth() + 1); // Months are 0-indexed
    const year = inputDate.getFullYear();
    const hours = pad(inputDate.getHours());
    const minutes = pad(inputDate.getMinutes());
    const seconds = pad(inputDate.getSeconds());

    // Format as DD-MM-YYYY HH:mm:ss
    const formatted_date_time = `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  
    return formatted_date_time
  }

  const handleOpportunityApply = async (data) => {
    pushMessage(PROJECT_DISPLAY_NAME, null, true);
    try {

      const formatted_meeting_start = convertDateTimeToPassAPI(oppData.meeting_start);
      const formatted_meeting_end = convertDateTimeToPassAPI(oppData.meeting_end);

      const payload = {
        // client: clientName,
        // account: accountName,
        client: oppData.client,
        account: oppData.account,
        selected_opportunities: data?.map((i) => i?.opportunity_name).join(" , "),
        selected_contacts: oppData.contact_name,
        user_id: user?.id,
        objective: oppData.objective,
        linkedin_url: oppData.linkedin_url,
        meeting_datetime: formatted_meeting_start,
        meeting_end_datetime: formatted_meeting_end,
        organizer_name: (user?.firstname + " "+user?.lastname),
        organizer_email: user?.email || ''
      };

      const requestBody = qs.stringify(payload);

      const response = await iq_api_v2.post(
        "meeting_prep/meeting_prep_document",
        requestBody,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );

      dispatch(
        FetchMeetingPrepsRequest({ clientName, accountName, userId: user?.id })
      );

      updateLastMessage("Hold on! We're getting your meeting ready...");

      setTimeout(() => {
        const followUp =
          response?.data?.next_prompt ||
          `Thanks. You’ll see it inside meeting prep in few seconds`;
             showBanner({ message: 'Meeting Added. Will be visible shortly',title:"Alert", type: 'success', duration: 10000 })

        pushMessage(PROJECT_DISPLAY_NAME, followUp);

        // ✅ Reset state only, don't clear chat
        setMessage("");
        setOppData({ contact_name: "", linkedin_url: "", objective: "", client: "", account: "" });
        setIsMeetingFlowActive(false); // show "Add another meeting" button
      }, 1500);
    } catch (err) {
      updateLastMessage(
        `❗ ${err?.response?.data?.message || "Something went wrong"}`
      );
    }
  };

  const isValidLinkedInUrl = (url) => {
    const pattern = /^https?:\/\/(www\.)?linkedin\.com\/in\/[a-zA-Z0-9-_%]+\/?$/;
    return pattern.test(url);
  }

  const handleUserInput = async (input) => {

    if (input && typeof input === 'object' && !Array.isArray(input) && 'meeting_date_time' in input) {

      let meeting_start = input?.meeting_date_time?.meeting_start || '';
      let meeting_end = input?.meeting_date_time?.meeting_end || '';

      pushMessage(user?.firstname || "User", "Meeting starts on "+meeting_start + " and " + " Meeting ends on "+meeting_end);

    }else{
      if (!input.trim() || !isMeetingFlowActive) return;
      pushMessage(user?.firstname || "User", input);
    }

    setMessage("");

    if (!oppData.contact_name) {
      setOppData((prev) => ({ ...prev, contact_name: input }));
      pushMessage(PROJECT_DISPLAY_NAME, <>Please share linkedin url</>);
      return;
    }

    if (!oppData.linkedin_url) {
      
      if(!isValidLinkedInUrl(input.trim())){
        pushMessage(PROJECT_DISPLAY_NAME, <>Invalid linkedin url. <br />Please share linkedin url</>);
        return;
      }

      oppData.linkedin_url = input;
      pushMessage(PROJECT_DISPLAY_NAME, <>Please give client name</>);
      return;
    }

    if (!oppData.client) {
      oppData.client = input;
      pushMessage(PROJECT_DISPLAY_NAME, <>Please give account name</>);
      return;
    }

    if (!oppData.account) {
      oppData.account = input;
      pushMessage(PROJECT_DISPLAY_NAME, <>Please select meeting date & time</>);
      pushMessage(
        PROJECT_DISPLAY_NAME,

        <SelectMeetingTimeForm handleUserInput={handleUserInput} />

        
      );
      return;
    }

    if (!oppData.meeting_start || !oppData.meeting_end) {

      if (input && typeof input === 'object' && !Array.isArray(input) && 'meeting_date_time' in input) {
        let meeting_start = input?.meeting_date_time?.meeting_start || '';
        let meeting_end = input?.meeting_date_time?.meeting_end || '';

        oppData.meeting_start = meeting_start;
        oppData.meeting_end = meeting_end;
      }
      pushMessage(PROJECT_DISPLAY_NAME, <>Please give meeting objective</>);
      return;
    }

    if (!oppData.objective) {
      // setOppData((prev) => ({ ...prev, objective: input }));
      oppData.objective = input;
      setOppData(oppData)
      pushMessage(PROJECT_DISPLAY_NAME, <>Please select opportunities</>);
      pushMessage(
        PROJECT_DISPLAY_NAME,
        <AddContactForm
          dropDownData={[...opportunitesData, ...winOpportunitesData]}
          onApplyDropdown={handleOpportunityApply}
        />
      );
      return;
    }
  };

  const renderMessages = (messages) =>
    messages.map((msg, index) => {
      const isUser = msg.sender === user?.firstname;
      const prevSender = index > 0 ? messages[index - 1].sender : null;
      const showSender = msg.sender !== prevSender;

      return (
        <div
          key={index}
          className={`message-wrapper ${isUser ? "align-right" : "align-left"}`}
        >
          {showSender && <p className="sender-name">{msg.sender}</p>}
          <div
            className={`message-bubble-${isUser ? "User" : "SalesPlay"} ${
              msg.isLoading ? "is-loading" : ""
            }`}
          >
            <div className="message-content">{msg.message}</div>
            {!msg.isLoading && msg.timestamp && (
              <div
                className={`message-timestamp-${isUser ? "User" : "SalesPlay"}`}
              >
                {msg.timestamp}
              </div>
            )}
          </div>
        </div>
      );
    });

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [message]);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [chatMessages]);

  const handleBackAndReset = () => {
    setMessage("");
    setOppData({ contact_name: "", linkedin_url: "", client: "", account: "", objective: "" });
    setChatMessages([]);
    setIsMeetingFlowActive(true);
    pushMessage(PROJECT_DISPLAY_NAME, `Hi ${user?.firstname}! 👋 Please enter the contact name.`);
    onBack();
  };

  const handleAddAnotherMeeting = () => {
    setIsMeetingFlowActive(true);
    pushMessage(PROJECT_DISPLAY_NAME, `Hi again! 👋 Please enter the contact name.`);
  };

  return (

    <div className="chatbox-container">
      <div className="chatbox-header" onClick={handleBackAndReset}>
        <img className="back-btn-img" src="/img/back_top.png" alt="Back" />
        <span className="back_chat_top">Back</span>
      </div>

      <div className="chatbox-messages-container" ref={containerRef}>
        {renderMessages(chatMessages)}
      </div>

      {!isMeetingFlowActive && (
        <div className="add-another-meeting-btn-container">
          <button className="add-another-meeting-btn" onClick={handleAddAnotherMeeting}>
            + Add another meeting
          </button>
        </div>
      )}

      <div className="chatbox-input-container">
        <textarea
          ref={textareaRef}
          className="chatbox-input"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Type here..."
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault(); // Prevents newline if needed
              handleUserInput(message);
            }
          }}
        />
        <button className="send-button" onClick={() => handleUserInput(message)}>
          <img className="send-button-img" src="/img/arrow-up.png" alt="Send" />
        </button>
      </div>
    </div>
  );
};

export default ChatContainerForMeetingPrep;
